export function formatFileSize(bytes: number) {
  if (bytes >= 1024 * 1024) {
    const megabytes = bytes / (1024 * 1024);
    return `${megabytes.toFixed(2)} MB`;
  }
  const kilobytes = bytes / 1024;
  return `${Math.round(kilobytes)} KB`;
}
